import { Badge, Group, Stack, Text } from '@mantine/core';
import { CollapsibleCard } from '@/components/CollapsibleCard';
import Link from '@/components/Link';
import {
  CLIENT_COMPANY_STATUS_COLORS,
  CLIENT_COMPANY_STATUS_LABELS,
  useContactPortfolio,
} from '@/models/clientCompanies';
import {
  CLIENT_PORTFOLIO_VIEW,
  useHasAnyPermission,
} from '@/models/permissions';

export function ClientCompaniesBlock({
  contactId,
  showContactServices,
}: {
  contactId: number | null | undefined;
  showContactServices: boolean;
}) {
  const canRead = useHasAnyPermission(CLIENT_PORTFOLIO_VIEW);
  const enabled = canRead && !!contactId;
  const { data } = useContactPortfolio(enabled ? Number(contactId) : 0);
  if (!enabled || !data) return null;
  const pending = data.services.filter(
    (s) => s.deliveryState === 'pending',
  ).length;

  return (
    <CollapsibleCard
      title="Client companies"
      rightSection={
        <Text size="xs" c="dimmed">
          {data.companies.length}
        </Text>
      }
    >
      <Stack gap={4}>
        {data.companies.length === 0 && (
          <Text size="sm" c="dimmed">
            No client companies yet.
          </Text>
        )}
        {data.companies.map((c) => (
          <Group key={c.id} justify="space-between" wrap="nowrap">
            <Link to={`~/client-companies/${c.id}`}>{c.name}</Link>
            <Badge
              size="xs"
              variant="light"
              color={CLIENT_COMPANY_STATUS_COLORS[c.status]}
            >
              {CLIENT_COMPANY_STATUS_LABELS[c.status] ?? c.status}
            </Badge>
          </Group>
        ))}
        {showContactServices && data.services.length > 0 && (
          <Group justify="space-between" wrap="nowrap" mt={4}>
            <Link to={`~/client-contacts/${contactId}`}>
              Services without a company: {data.services.length}
            </Link>
            {pending > 0 && (
              <Badge size="xs" color="orange" variant="light">
                {pending} not delivered
              </Badge>
            )}
          </Group>
        )}
      </Stack>
    </CollapsibleCard>
  );
}
